import { LearnWhyDialogContext } from '@rhg/providers/learn-why-dialog';
import { useContext } from 'react';

export function useLearnWhyDialog() {
    return useContext(LearnWhyDialogContext);
}
